import { useContext } from "react";
import { MenuContext } from 'src/context/MenuContext';
import { useAuth } from 'src/hooks/useAuth';

import '../../css/bootstrap.min.css';
import '../../css/style.css';
import '../../lib/mmenu/core/css/jquery.mmenu.all.css';
import '../../lib/mmenu/extensions/css/jquery.mmenu.widescreen.css';
import '../../lib/datetimepicker/css/bootstrap-datetimepicker.min.css';
import '../../css/jquery-ui.min.css';
import '../../css/jquery-ui.structure.min.css';
import '../../css/jquery-ui.theme.min.css';
import '../../css/bootstrap.min.css';
import logo from '../../img/logo.svg';
import CustomLoader from "./CustomLoader";
import { Link } from 'react-router-dom';


export default function Header() {

  const { user: userData } = useAuth();

  const { visibleMenu, setVisibleMenu } = useContext(MenuContext); // Access the context

  const handleMenu = (e) => {
    e.preventDefault();
    setVisibleMenu((prev) => !prev); // Toggle the menu visibility
  };

  const htmlElement = document.documentElement;
  if (visibleMenu) {
    htmlElement.classList.add('mm-opening');
  } else {
    htmlElement.classList.remove('mm-opening');
  }
  return (
    <div className="navbar navbar-fixed-top navbar-absolute" role="navigation">
      <header className="header-area">
        <div className="header-logo">
          <a href="/"><img src={logo} alt="EDAMAME" className="title_logo" /></a>
        </div>
        <div className="header-nav">
          <div className="status-area">
            <div className="status-box">
              <div className="col-sm-9">
                <span id="user-icon-detail" className={`statusicon sta-icon${userData?.icon_num}`}></span>
              </div>
              {userData ? (
                <span className="status-name">
                  Thank you for your hard work Mr.
                  <Link to={`/userEdit/${userData.id}`}>
                    {userData.name}
                  </Link>
                </span>
              ) : (<span className="status-name"><CustomLoader /></span>
              )}
            </div>
          </div>
          <button type="button" id="mame_knowledge_modal_open" className="btn btn-default btn-flex btn-success" title="ナレッジ投稿">
            <span className="glyphicon glyphicon-book" aria-hidden="true"></span>
          </button>
          &nbsp;
          <a href="#" id="hamburger" className="Fixed btn btn-default" onClick={handleMenu}><span></span></a>
        </div>
      </header>

    </div>
  );
}





